<template>
  <div>
    <basic-container>
      <avue-crud
        :option="tableOption"
        :data="tableData"
        :table-loading="tableLoading"
        :page="page"
        ref="crud"
        @row-save="handleSave"
        @search-change="searchChange"
        @refresh-change="refreshChange"
        @search-reset="searchClear"
        @size-change="pageSizeChange"
        @current-change="pageChange"
        @selection-change="handleSelectionChange"
      >
        <template slot-scope="scope" slot="menuLeft">
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="small"
            plain
            @click.stop="handleAdd()"
            >分配新预约卡</el-button
          >
        </template>
        <template slot-scope="scope" slot="menu">
          <el-button
            type="success"
            size="small"
            icon="el-icon-view"
            plain
            @click.stop="toDetail(scope.row, scope.index)"
            >预约卡详情</el-button
          >
        </template>
        <template slot-scope="scope" slot="agencyForm">
          <el-select
            v-model="workShopItem"
            filterable
            placeholder="请选择经销商"
            required
            value-key="id"
          >
            <el-option
              v-for="workShopItem in workShopItems"
              :key="workShopItem.id"
              :label="workShopItem.shopName"
              :value="workShopItem"
            ></el-option>
          </el-select>
        </template>
        <template slot-scope="scope" slot="serviceHotLineForm">
          <el-input
            v-model="currentServiceHotLine"
            placeholder="请输入服务热线"
            required
          ></el-input>
        </template>
      </avue-crud>
    </basic-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { appointmentCardOption } from "@/const/work/appointmentCard";
import { getList } from "@/api/salesCloud/serviceHotline.js";
import {
  findWorkOrderList,
  findWorkShopItem,
  addCard,
} from "@/api/work/appointmentCard";
export default {
  name: "workOrder",
  data() {
    return {
      tableOption: appointmentCardOption, //表格设置属性
      tableData: [], //表格的数据
      workShopItems: [], //服务项目
      workShopItem: {}, //服务项目
      tableLoading: false,
      val: "",
      currentServiceHotLine: "", // 当前服务热线
      currentDate: new Date(),
      page: {
        total: 0, //总页数
        currentPage: 1, //当前页数
        pageSize: 10, //每页显示多少条
      },
    };
  },
  created() {
    this.handleList();
    // this.updateServiceHotLine(); // 在组件创建时更新服务热线
    findWorkShopItem().then((res) => {
      let data = JSON.parse(res.data);
      this.workShopItems = data.rows;
    });
    /* const currentMonth = this.currentDate.getMonth() + 1;
    // 根据当前月份的奇偶性，决定显示哪个服务热线号码
    if (currentMonth % 2 === 0) {
      // 偶数月份显示双数号码
      this.currentServiceHotLine = "13982224203   19828518609";
    } else {
      // 奇数月份显示单数号码
      this.currentServiceHotLine = "15802812374    18349278032";
    } */
  },
  watch: {},
  mounted() {},
  computed: {
    ...mapGetters(["permission"]),
  },
  props: [],
  methods: {
    /* updateServiceHotLine() {
      // 获取当前日期
      this.currentDate = new Date();
    }, */
    getList() {
      this.loading = true;
      const data = Object.assign(
        {
          pageNum: this.page.currentPage,
          pageSize: this.page.pageSize,
        },
        this.params
      );
      this.data = [];
      getList(data).then((res) => {
        const data = JSON.parse(res.data);
        this.loading = false;
        const result = data.rows[0];
        this.currentServiceHotLine = result.serviceHotline;
      });
    },
    toDetail(row) {
      // 跳转到详情页
      this.$router.push({
        path: "/work/appointmentCard/detail",
        query: {
          id: row.id,
          shopName: row.shopName,
        },
      });
    },
    clean() {
      this.$refs.crud.searchForm.agency = "";
      this.$refs.crud.searchForm.mobile = "";
      this.$refs.crud.searchForm.shopName = "";
      this.$refs.crud.searchForm.serviceHotLine = "";
      this.workShopItem = "";
    },
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = this.page.currentPage;
      params.size = pageSize;
      findWorkOrderList(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: pageSize,
        };
        this.tableLoading = false;
      });
    },
    pageChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page;
      params.size = this.page.pageSize;
      findWorkOrderList(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page,
          pageSize: this.page.pageSize,
        };
        this.tableLoading = false;
      });
    },
    /* 
    清空搜索条件
    */
    searchClear() {
      this.clean();
    },
    searchChange(params) {
      this.tableLoading = true;
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      params.shopName = this.$refs.crud.searchForm.agency;
      findWorkOrderList(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: params.page,
          pageSize: params.size,
        };
        this.tableLoading = false;
      });
    },
    refreshChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page.currentPage;
      params.size = page.pageSize;
      findWorkOrderList(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page.currentPage,
          pageSize: page.pageSize,
        };
        this.tableLoading = false;
      });
    },
    handleDetail() {},
    /**
     * @title 打开新增窗口
     * @detail 调用crud的handleadd方法即可
     *
     **/
    handleAdd() {
      // 如果选择了多个经销商，就不能新增，提示用户只能选择一个经销商
      if (this.val.length > 1) {
        this.$message({
          message: "只能选择一个经销商",
          type: "error",
        });
        return;
      } else if (this.val.length == 1) {
        this.$refs.crud.rowAdd();
      } else {
        this.clean();
        this.$refs.crud.rowAdd();
      }
    },
    /**
     * @title 获取数据
     * @detail 赋值为tableData表格即可
     *
     **/
    handleList() {
      this.tableLoading = true;
      let params = {
        page: this.page.currentPage,
        size: this.page.pageSize,
      };
      findWorkOrderList(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize,
        };
        this.tableLoading = false;
      });
      this.getList();
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
    handleSave(row, done) {
      row.shopId = this.workShopItem.id;
      if (row.printType == "A4" && row.num % 2 != 0) {
        this.$message({
          message: "A4纸模板打印数量必须为双数",
          type: "error",
        });
        done();
        this.$refs.crud.rowAdd();
        this.$refs.crud.$refs.tableForm.form.serviceHotLine =
          row.serviceHotLine;
        this.$refs.crud.$refs.tableForm.form.printType = row.printType;
        return;
      } else if (row.num < 1) {
        this.$message({
          message: "打印数量不能小于1",
          type: "error",
        });
        done();
        return;
      }
      let params = {
        shopId: row.shopId,
        printType: row.printType,
        num: row.num,
        serviceHotLine: this.currentServiceHotLine,
      };

      addCard(params).then((response) => {
        console.log(response);
        // 提取文件名
        const filename = response.headers["content-disposition"].match(
          /filename=(.*)/
        )[1];
        // 将二进制流转为blob
        const blob = new Blob([response.data], {
          type: "application/octet-stream",
        });
        if (typeof window.navigator.msSaveBlob !== "undefined") {
          // 兼容IE，window.navigator.msSaveBlob：以本地方式保存文件
          window.navigator.msSaveBlob(blob, decodeURI(filename));
        } else {
          // 创建新的URL并指向File对象或者Blob对象的地址
          const blobURL = window.URL.createObjectURL(blob);
          // 创建a标签，用于跳转至下载链接
          const tempLink = document.createElement("a");
          tempLink.style.display = "none";
          tempLink.href = blobURL;
          tempLink.setAttribute("download", decodeURI(filename));
          // 兼容：某些浏览器不支持HTML5的download属性
          if (typeof tempLink.download === "undefined") {
            tempLink.setAttribute("target", "_blank");
          }
          // 挂载a标签
          document.body.appendChild(tempLink);
          tempLink.click();
          document.body.removeChild(tempLink);
          // 释放blob URL地址
          window.URL.revokeObjectURL(blobURL);
          this.handleList();
        }
      });
      done();
    },
    handleSelectionChange(val) {
      var that = this;
      that.val = val;
      // 只能选择一条数据
      if (val.length > 1) {
        this.$refs.crud.tableSelect = [val[val.length - 1]];
        this.$message({
          showClose: true,
          message: "只能选择一个经销商",
          type: "error",
        });
        return;
      }
      this.workShopItem = val[0];
    },
  },
};
</script>

<style lang="scss" scoped>
.remittanceButton {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
}
.remittance {
  .recharge {
    margin-top: 10px;
  }
}
.table-container {
  padding: 8px 10px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 30%;
}
.el-dialog {
  width: 30% !important;
}
</style>
